import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { ExternalUserEQuery } from './models/external-user-e-query';

export interface ReadEQueryItem<T> {
    readonly eQueryId: number;
    readonly afterRead: (eQuery: T) => void;
}

@Injectable()
export class ReadEQueryEmitter<T = unknown> {
    private readonly eQueryIdEmitter = new EventEmitter<ReadEQueryItem<T>>();

    public get readEQueryId(): Observable<ReadEQueryItem<T>> {
        return this.eQueryIdEmitter;
    }

    public emit(readItem: ReadEQueryItem<T>) {
        this.eQueryIdEmitter.emit(readItem);
    }
}

export type ExternalUserReadEQueryEmitter = ReadEQueryEmitter<ExternalUserEQuery>;